
import { defineComponent } from 'vue'
import DatePicker from '../date-picker/DatePicker.vue'
import FiltersDialog from '../dialogs/FiltersDialog.vue'
import axios from 'axios'
import {
  lookupCampaigns,
  lookupGeos,
  lookupLandings,
  lookupOfferCategories,
  lookupOffers,
  lookupTrafficProperties,
  lookupSids,
} from '@/utils/lookups'
import { getFiltersData, initFilterOptions } from '@/utils/filters'
import { FiltersType } from '@/utils/request'
import { lookupGroups } from '@/utils/lookups'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'Filters',
  components: { DatePicker, FiltersDialog },
  props: ['reset', 'currentFilters', 'change', 'changeAll', 'export', 'tab'],
  async created() {
    if (this.$route.query.campaignId) {
      this.campaigns = (await axios.get('/api/campaigns')).data
    }
    if (this.$q.screen.width < 600) {
      await initFilterOptions(this)
    }
  },
  computed: {
    ...mapState('authModule', ['isMB']),
    hideForStatistics(): boolean {
      return !this.$route.path.includes('statistics')
    },
    hideForConversions(): boolean {
      return !this.$route.path.includes('conversions')
    },
    hideForCampaigns(): boolean {
      return !this.$route.path.includes('campaigns')
    },
    hideForOffers(): boolean {
      return !this.$route.path.includes('offers')
    },
    hideForDashboard(): boolean {
      return !this.$route.path.includes('dashboard')
    },
    hideForPostbacks(): boolean {
      return !this.$route.path.includes('postbacks')
    },
    hideForLogs(): boolean {
      return !this.$route.path.includes('clicklog')
    },
    hideForClickLogs(): boolean {
      return this.tab !== 'clicks'
    },
  },
  data: function() {
    return {
      filters: { ...this.currentFilters },
      showFiltersDialog: false,
      ...getFiltersData(),
      groupByMulti: [
        this.currentFilters?.groupBy,
        this.currentFilters?.groupBy2,
        this.currentFilters?.groupBy3,
      ].filter(Boolean),
    }
  },
  watch: {
    search() {
      this.onChangeFilters('name', this.search)
    },
    currentFilters() {
      this.filters = { ...this.currentFilters }
      this.search = this.currentFilters.name
      this.groupByMulti = this.buildGroupByMulti()
    },
  },
  methods: {
    resetFilters() {
      this.search = null
      this.$emit('reset')
    },
    onChangeFilters(field: string, value: string | null) {
      if (field === 'vertical') {
        this.$emit('change', 'offerCategoryId', null)
      }
      this.$emit('change', field, value)
    },
    submitAll(filters: FiltersType) {
      this.$emit('changeAll', filters)
    },
    buildGroupByMulti() {
      const result = []
      if (this.filters.groupBy) result.push(this.filters.groupBy)
      if (this.filters.groupBy2) result.push(this.filters.groupBy2)
      if (this.filters.groupBy3) result.push(this.filters.groupBy3)
      return result
    },
    onChangeGroupByMulti(values: string[]) {
      const [g1, g2, g3] = values || []
      this.filters.groupBy = g1 || null
      this.filters.groupBy2 = g2 || null
      this.filters.groupBy3 = g3 || null
      this.$emit('change', 'groupBy', this.filters.groupBy)
      this.$emit('change', 'groupBy2', this.filters.groupBy2)
      this.$emit('change', 'groupBy3', this.filters.groupBy3)
    },
    async getOffers(value: string, update: Function) {
      await lookupOffers(this, value, update)
    },
    async getTrafficProperties(value: string, update: Function) {
      await lookupTrafficProperties(this, value, update)
    },
    async getCampaigns(value: string, update: Function) {
      await lookupCampaigns(this, value, update)
    },
    async getGeos(value: string, update: Function) {
      await lookupGeos(this, value, update, false, this.isMB)
    },
    async getOfferCategories(value: string, update: Function) {
      await lookupOfferCategories(this, value, update)
    },
    async getSids(value: string, update: Function, sidField: string) {
      await lookupSids(this, value, update, sidField)
    },
    async getLandings(
      value: string,
      update: Function,
      isLandingFilter: boolean,
    ) {
      await lookupLandings(this, value, update, isLandingFilter)
    },
    onChangeDate(date: string[]) {
      this.filters.dateFrom = date[0]
      this.filters.dateTo = date[1]
      this.$emit('changeAll', this.filters)
    },
    onChangeConversionDate(date: string[]) {
      this.filters.conversionDateFrom = date[0]
      this.filters.conversionDateTo = date[1]
      this.$emit('changeAll', this.filters)
    },
    async getCampaignsGroups(value: string, update: any) {
      await lookupGroups(this, value, update, 'campaign')
    },
  },
})
